<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-form @submit.prevent="submit"
                ref="form"
                :disabled="form.busy">
          <v-card class="mb-4">
            <v-card-title class="d-flex flex-column text-uppercase align-center justify-center">
              <v-img src="/v2/images/mobilelocker_logo.png"
                     alt="Mobile Locker">
              </v-img>
              Unsubscribe from Faxes
            </v-card-title>
            <v-progress-linear indeterminate
                               v-if="form.busy">
            </v-progress-linear>
            <v-card-text>
              <p>
                If you received a fax and you want to unsubscribe from future faxes, enter the code from the cover page.
              </p>
              <v-text-field v-if="1===2"
                            v-model="form.fax_number"
                            label="Fax Number"
                            placeholder="#-(###)-###-####"
                            v-mask="'#-(###)-###-####'"
                            required
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('fax_number')">
              </v-text-field>

              <v-text-field v-model="form.code"
                            label="Unsubscribe Code"
                            placeholder="The eight-character code from the fax cover page"
                            v-mask="'XXXXXXXX'"
                            @input="(val) => (form.code = form.code.toUpperCase())"
                            required
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('code')"
                            min="8"
                            max="8">
              </v-text-field>
            </v-card-text>
            <v-card-actions class="d-block">
              <v-btn type="submit"
                     :disabled="form.busy"
                     block
                     color="primary"
                     class="mb-4">
                Unsubscribe
              </v-btn>

              <v-btn @click.prevent="getHelp"
                     block
                     class="ml-0">
                Get Help
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-alert v-if="result"
                   type="success">
            {{ result.fax_number }} is unsubscribed.
          </v-alert>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import faxService from '../../../services/faxService';
import formValidation from '../../../plugins/formValidation';
import helpScoutService from '../../../../../ml/services/helpScoutService';

export default {
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        code: '',
        fax_number: '',
      }),
      result: null,
    }
  },
  created() {

  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.result = null;
      faxService.unsubscribeCode(this.form)
        .then(data => {
          this.result = data;
          this.form.reset();
          this.form.clear();
          this.$refs.form.resetValidation();
        })
        .catch(err => {
          if (err.response && err.response.status === 422) {

          } else {
            this.$toast.error('There was a problem.');
          }
        })
    },
    getHelp() {
      helpScoutService.show(null);
    }
  }
}
</script>
